export enum AppEvent {
  AML_VERIFICATION_ADD = "aml-verification:add",
  AML_VERIFICATION_UPDATE = "aml-verification:update",
  ID_VERIFICATION_ADD = "id-verification:add",
  ID_VERIFICATION_UPDATE = "id-verification:update",
  SUB_LINK_CLICKED = "sub-link:click",
}
